import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { PaymentPage } from "../../pages/payment/payment";
import { PaymentUpdatePage } from "../../pages/payment/payment_update";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-payment_view",
  templateUrl: "payment_view.html",
})
export class PaymentViewPage {
  public static readonly PAYMENT_PY_UPD_ACCESS = "updatePayment";
  public static readonly PAYMENT_PY_DEL_ACCESS = "deletePayment";

  private hasUpdPaymentAccess: boolean = false;
  private hasDelPaymentAccess: boolean = false;
  private payment: any;
  private id: string;
  private mb_hashname: string;
  private mb_photo: string;
  private mb_status: string;
  private py_date: string;
  private py_type: string;
  private py_description: string;
  private py_amount: string;
  private styleName: string ="";

  constructor(private configService: ConfigService,private authService: AuthService, public navCtrl: NavController, public navParams: NavParams
    ,         public alertCtrl: AlertController, private db: DbserviceProvider,
  ) {
    console.log("PaymentViewPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
  }

  private ionViewWillEnter() {
    console.log("PaymentViewPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("PaymentViewPage onInitPage");
    this.id = this.navParams.get("payment").id;
    if (this.authService.currentUser) {
      this.hasUpdPaymentAccess = this.db.hasAccess(PaymentViewPage.PAYMENT_PY_UPD_ACCESS);
      this.hasDelPaymentAccess = this.db.hasAccess(PaymentViewPage.PAYMENT_PY_DEL_ACCESS);
    }
  }

  private ngOnDestroy() {
    console.log("PaymentViewPage ngOnDestroy");
  }

  private updatePayment(id: any) {
    console.log("PaymentViewPage updatePayment");
    const formValues: any = {
      "id": this.id,
      "mb_hashname": this.mb_hashname,
      "mb_photo": this.mb_photo,
      "mb_status": this.mb_status,
      "py_amount": this.py_amount,
      "py_date": this.py_date,
      "py_description": this.py_description,
      "py_type": this.py_type,
    };
    this.navCtrl.push(PaymentUpdatePage, {
      "payment": formValues,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/payment/payment_view.ts